module.exports = __webpack_public_path__ + "assets/devices.ec8dfaf6.svg";